import * as QueryString from "querystringify";
import { LOCATION_CHANGE, push, replace } from "react-router-redux";
import { createAction } from "redux-actions";
import { Thunk } from "./Thunk";
import { Utility } from "../utils";
import { LocationDescriptor, LocationState } from "history";

/** This is what is returned from the payload when a path changes */
export interface LocationChangeProps {
    hash: string;
    key?: string;
    pathname: string;
    search: string;
}

export type LocationChangeActionPayload = LocationChangeProps;

export const onPathChanged = createAction<LocationChangeActionPayload, LocationChangeProps>(
    LOCATION_CHANGE, (payload) => (payload),
);

/**
 * Replaces the current history
 */
export const replaceHistory = (location: LocationDescriptor, state?: LocationState): Thunk => async (dispatch, getState) => {
    dispatch(replace(location, state));
};

/**
 * Replaces the query parameters of the url
 * @param query Flat query parameters object
 * @param [overwrite] Whether or not to overwrite the current query params. Defaults to false
 */
export const replaceQueryParams = (query: object, overwrite: boolean = false, state?: any): Thunk => async (dispatch, getState) => {
    const currentQuery = (overwrite && overwrite)
        ? query
        : Object.assign(QueryString.parse((getState().router.location || {} as any).search || ""), query);

    Object.keys(currentQuery).map((k) => {
        const v = currentQuery[k];
        if (!v)
            delete currentQuery[k];
    });

    const qs = Utility.queryParamsToUrl(currentQuery);

    dispatch(replace({ search: qs ? ("?" + qs) : "" }, state));
};

/**
 * Updates the query parameters of the url
 * @param query Flat query parameters object
 * @param [overwrite] Whether or not to overwrite the current query params. Defaults to false
 */
export const updateQueryParams = (query: object, overwrite: boolean = false, state?: any): Thunk => async (dispatch, getState) => {
    const currentQuery = (overwrite && overwrite)
        ? query
        : Object.assign(QueryString.parse((getState().router.location || {} as any).search || ""), query);

    Object.keys(currentQuery).map((k) => {
        const v = currentQuery[k];
        if (!v)
            delete currentQuery[k];
    });

    const qs = Utility.queryParamsToUrl(currentQuery);

    dispatch(push({ search: qs ? ("?" + qs) : "" }, state));
};



// WEBPACK FOOTER //
// ./src/actions/RouterActions.ts